/* eslint no-underscore-dangle: 0 */
import Anchor from './Anchor';
import directive from './anchor.directive';

export default function install(Vue) {
	Vue.mixin({
		beforeCreate() {
			if (typeof this.$options.anchors !== "undefined") {
				this._rootAnchorComponent = this;
				this._anchorsManagerClass = this.$options.anchors;
			} else {
				this._rootAnchorComponent = (this.$parent && this.$parent._rootAnchorComponent) || this;
			}
		},
	});

	Object.defineProperty(Vue.prototype, '$anchors', {
		get() {
			return this._rootAnchorComponent._anchorsManagerClass;
		},
	});

	Vue.component(Anchor.name, Anchor);
	Vue.directive("anchor", directive);
}



// WEBPACK FOOTER //
// ./src/plugins/vue-anchors-plugin/install.js